module.exports = __webpack_public_path__ + "static/media/KOL.dca4b6f9.mp4";